import logo from './redIcon.png';
import './App.css';
import React from "react";

function Discord() {
  return (
    <div className="App bg-gradient-to-br from-ddp to-darkp">
      <header className="header pt-32">
        <img src={logo} className="App-logo" alt="logo" />
        <p className="fontTitle text-2xl md:text-4xl lg:text-6xl">
          Discord Servers
        </p>
      </header>
      <div className="header mt-6">
        <p className="text-center text-base md:text-xl">CaL Pack World has a <b>Discord Server!</b></p>
        <p className="text-center text-base md:text-lg mt-3">In the Discord server, you can discuss the site, talk about packs, report bugs, and more!</p>
        <p className="text-center text-base md:text-lg">You'll also be able to get notified when your packs are uploaded.</p>
        <button onClick={() => window.open("https://discord.gg/nsmRZMR3y3")} className="bg-darkc hover:bg-ddc transition duration-50 px-10 py-2 rounded-lg text-base mt-3">Join</button>
      </div>
      <div className="header mt-10 mb-64 lg:mb-24 xl:mb-20">
        <p className="text-center text-xl md:text-2xl">Last Quarter Studios Discord Server</p>
        <p className="text-center text-base md:text-lg mt-3">To talk about Cats are Liquid in general (and other games by Last Quarter Studios), join their official Discord server!</p>
        <button onClick={() => window.open("https://discord.com/invite/Qa5sCd9")} className="bg-darkgo hover:bg-ddgo transition duration-50 px-10 py-2 rounded-lg text-base mt-3">Join</button>
      </div>
      <br/>
    </div>
  );
}

// <WorldPackPreview title={packName.current.value} desc={packDesc.current.value} author={packAuthor.current.value} allTag={allTags} allStat={allStatus}/>
          
export default Discord;